
import {HTTP} from './repository'
import {HTTPImage} from './repository'
import {ReportHTTP} from './repository'
import {HTTPTerminal} from './repository'
export default{
    methods:{
        AddTokenToAPI(token){
            
            HTTP.defaults.headers.post['token']=token
        },
        AddUserToAPI(user){
            //console.log('add user to api ' + user.userId + ' ' + user.userKey)
            HTTP.defaults.headers.post['adminuser']=user.userId + '|' + user.userKey
        },
        // SER-331: send the SIGNED per-user admin token (from the login response) in the
        // "adminuser" header on EVERY verb, so admin API calls are authorized per-user instead
        // of by the client-exposed X-API-Key. Supersedes the plaintext post-only header above.
        AddAdminTokenToAPI(token){
            if(token){
                HTTP.defaults.headers.common['adminuser']=token
                // remove the legacy plaintext post override so POST mutations also carry the signed token
                if(HTTP.defaults.headers.post){ delete HTTP.defaults.headers.post['adminuser'] }
            }
        },
        // ECommerceAdmin fork: authenticate to PaymentAPI via X-API-Key on every verb.
        // Set on 'common' so GET/PUT/POST all carry the key (REST category endpoints).
        AddApiKeyToAPI(apiKey){
            HTTP.defaults.headers.common['X-API-Key']=apiKey
        },
        // REST helpers for the ecommerce-native admin endpoints (GetSecureAdminUser).
        async callAPI_Get(method){
            try{
                var response = await HTTP.get(method)
                if(response.data.Successful==false){
                    return this.getFailureResponse((response.data.RequestException && response.data.RequestException.Message) || 'Request failed')
                }
                return response.data
            }
            catch(e){
                console.log('!' + e)
                return this.getFailureResponse(e.message)
            }
        },
        async callAPI_Put(method,req){
            try{
                var response = await HTTP.put(method,req)
                if(response.data.Successful==false){
                    return this.getFailureResponse((response.data.RequestException && response.data.RequestException.Message) || 'Request failed')
                }
                return response.data
            }
            catch(e){
                console.log('!' + e)
                return this.getFailureResponse(e.message)
            }
        },
        async callAPI_Delete(method){
            try{
                var response = await HTTP.delete(method)
                if(response.data.Successful==false){
                    return this.getFailureResponse(response.data.RequestException ? response.data.RequestException.Message : 'Delete failed')
                }
                return response.data
            }
            catch(e){
                console.log('!' + e)
                return this.getFailureResponse(e.message)
            }
        },
        // Multipart upload via the main (X-API-Key, tenant-prefixed) HTTP instance so the
        // admin-authenticated upload route receives the key. HTTPImage has a different base
        // and no key, so it is NOT used for admin uploads.
        async callAPI_Upload(method,formData){
            try{
                var response = await HTTP.post(method,formData,{headers:{'Content-Type':'multipart/form-data'}})
                return response.data
            }
            catch(e){
                console.log('!' + e)
                return this.getFailureResponse(e.message)
            }
        },
        AddConfigToAPI(configoverride){
            console.log('add config to api ' + configoverride)
            ReportHTTP.defaults.headers.post['configoverride']=configoverride
        },
        getFailureResponse(message){
            return {
                'Successful':false,
                'Message':message
            }
        },
        async callAPI(req,method){
            try{
                
                var response = await HTTP.post(method,req)
                if(response.data.Successful==false){
                    return this.getFailureResponse((response.data.RequestException && response.data.RequestException.Message) || 'Request failed')
                }
                return response.data
            }
            catch(e){
                console.log('!' + e)
                return this.getFailureResponse(e.message)
            }
        }, 
        async callAPI_Report(req,method){
            try{
                
                var response = await ReportHTTP.post(method,req)
                if(response.data.Successful==false){
                    return this.getFailureResponse((response.data.RequestException && response.data.RequestException.Message) || 'Request failed')
                }
                return response.data
            }
            catch(e){
                console.log('!' + e)
                return this.getFailureResponse(e.message)
            }
        }, 
        async callAPI_Image(req,method){
            try{
                
                var response = await HTTPImage.post(method,req)
                if(response.data.Successful==false){
                    return this.getFailureResponse((response.data.RequestException && response.data.RequestException.Message) || 'Request failed')
                }
                return response.data
            }
            catch(e){
                console.log('!' + e)
                return this.getFailureResponse(e.message)
            }
        }, 
        async callAPI_Terminal(req,method){
            try{
                HTTPTerminal.defaults.withCredentials=false;
                var response = await HTTPTerminal.post(method,req)
                console.log(response)
                //if(response.data.Successful==false){return this.getFailureResponse((response.data.RequestException && response.data.RequestException.Message) || 'Request failed')}
                return response.data
            }
            catch(e){
                console.log(e)
                return this.getFailureResponse(e.message)
            }
        }, 
        AddHeaderToTerminalAPI(key,value){
            console.log('add header ' + key + ' ' + value)
            if(key=='accept'){
                delete HTTPTerminal.defaults.headers.common['Accept']
                console.log('delete accept  header')
            }
            HTTPTerminal.defaults.headers.post[key]=value
        },
        async loadEcommerceAdminConfig(){
            try {
                const response = await this.callAPI(null, 'ecommerceadminconfig')
                if (!response || response.Successful === false) return
                const cfg = response.config || {}
                window.ECOM_SHOW_ONLINE     = !!cfg.showOnlineFields
                window.SHOW_SHOWONLINE      = !!cfg.showOnlineFields
                window.ECOM_IMAGE_ADMIN     = !!cfg.showImageAdmin
                window.ECOM_TYPE_ADMIN      = !!cfg.showProductTypeAdmin
                window.ECOM_LINE_ADMIN      = !!cfg.showProductLineAdmin
                window.ECOM_CATEGORY_ADMIN  = !!cfg.showCategoryAdmin
                window.ECOM_SHIPPING        = !!cfg.showShippingFields
                window.ECOM_INVENTORY_GATES = !!cfg.showInventoryGates
            } catch {
                // non-fatal — all ECOM_* flags remain undefined (falsy)
            }
        },
        // Client-side image validation for admin uploads (type + size).
        // Returns { ok:Boolean, message:String }.
        validateImageFile(file){
            if(!file){ return {ok:false, message:'Choose a file'} }
            var allowed = ['image/jpeg','image/jpg','image/png','image/gif','image/webp']
            if(file.type && allowed.indexOf(file.type.toLowerCase()) === -1){
                return {ok:false, message:'Unsupported file type — use JPG, PNG, GIF, or WEBP'}
            }
            var maxBytes = 5 * 1024 * 1024 // 5 MB
            if(file.size > maxBytes){
                return {ok:false, message:'Image is too large — max 5 MB (yours is '+(file.size/1048576).toFixed(1)+' MB)'}
            }
            return {ok:true, message:''}
        },
    },

}